import React, { useRef, useEffect } from 'react';
import paper from 'paper';

const Radio = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);

    const waveCount = 5;
    const waveColors = ['red', 'red', 'red', 'red', 'red'];
    const waves = [];

    for (let i = 0; i < waveCount; i++) {
      const wave = new paper.Path();
      wave.strokeColor = waveColors[i];
      wave.strokeWidth = 5;

      for (let x = 0; x <= paper.view.size.width; x += 10) {
        const y = paper.view.size.height / 2 + Math.sin(x / 50 + i) * 150;
        wave.add(new paper.Point(x, y));
      }

      waves.push(wave);
    }

    const onMouseMove = (event) => {
      const mouseY = event.point.y;

      for (let i = 0; i < waveCount; i++) {
        const wave = waves[i];
        for (let j = 0; j < wave.segments.length; j++) {
          const segment = wave.segments[j];
          const distance = Math.abs(segment.point.y - mouseY);
          const amplitude = Math.max(1 - distance / 100, 0.5);
          segment.point.y = paper.view.size.height / 2 + Math.sin(segment.point.x / 50 + i) * 300 * amplitude;
        }
      }
    };

    paper.view.on('mousemove', onMouseMove);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.project.clear();
    };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />;
};

export default Radio;
